import React, { Component } from 'react';
import TextareaAutosize from 'react-textarea-autosize';


export class TextareaWithFormatting extends Component {

  state = {
    text: '',
  };
  element = null;

  componentDidMount(){
    const { value } = this.props;
    this.setState({ text: value || '' });
  }

  componentDidUpdate(prevProps){
    const { value } = this.props;
    if (prevProps.value !== value) {
      this.setState({ text: value || '' });
    }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    this.setState({ text: e.target.value });
    if (onChange) {
      onChange(e);
    }
  };

  onKeyDown = (e) => {
    const { onKeyDown } = this.props;
    const value = e.target.value.trim();
    if (onKeyDown) {
      onKeyDown(e);
    }

    if ((e.ctrlKey || e.metaKey) && value) { // Ctrl or Cmd pressed
      if (e.keyCode === 73) {
        this.formatSelectedText('italic');
        e.preventDefault();
      }
      else if (e.keyCode === 66) {
        this.formatSelectedText('bold');
        e.preventDefault();
      }
      else if (e.keyCode === 76) {
        this.formatSelectedText('list');
        e.preventDefault();
      }
    }
  };

  formatSelectedText = async (type) => {
    const { selectionStart, selectionEnd, value } = this.element;
    const selectedText = value.substr(selectionStart, selectionEnd - selectionStart);
    const textBeforeSelection = value.substr(0, selectionStart);
    const textAfterSelection = value.substr(selectionEnd);
    let updatedText;
    let updatedCaretPosition;

    if (type === 'bold' || type === 'italic') {
      if (!selectedText) {
        return;
      }
      const wrapSymbol = type === 'bold' ? '*' : '_';
      updatedText = textBeforeSelection
        + wrapSymbol
        + selectedText
        + wrapSymbol
        + textAfterSelection;
      updatedCaretPosition = selectionEnd + (wrapSymbol.length * 2);
    }
    else if (type === 'list') {
      const prefixSymbol = '* ';
      let firstLineIncludedInSelectionBeginsAt = textBeforeSelection.lastIndexOf('\n');
      if (firstLineIncludedInSelectionBeginsAt === -1) {
        firstLineIncludedInSelectionBeginsAt = 0;
      }
      const lastLineIncludedInSelectionEndsAt = textAfterSelection.indexOf('\n') + textBeforeSelection.length + selectedText.length - 1;
      const textBeforeSelectedLines = value.substr(0, firstLineIncludedInSelectionBeginsAt);
      const selectedLinesText = value.substr(firstLineIncludedInSelectionBeginsAt, lastLineIncludedInSelectionEndsAt - firstLineIncludedInSelectionBeginsAt + 1);
      const selectedLinesArr = selectedLinesText.replace(/^\n/, '').split(/\n/);
      const textAfterSelectedLines = value.substr(lastLineIncludedInSelectionEndsAt + 1);

      updatedText = (textBeforeSelectedLines ? textBeforeSelectedLines + '\n' : '')
        + selectedLinesArr.map(row => prefixSymbol + row).join('\n')
        + textAfterSelectedLines;

      updatedCaretPosition = selectionEnd + (selectedLinesArr.length * prefixSymbol.length);
    }

    if (updatedText) {
      /**
       * The following 3 lines are required in order to preserve "undo" history in textarea (e.g. when pressing Ctrl+Z)
       * @see https://stackoverflow.com/a/41274320/4373597
       */
      this.element.selectionStart = 0;
      this.element.selectionEnd = value.length;
      document.execCommand('insertText', false, updatedText);

      this.setState({ text: updatedText }, () => {
        this.element.selectionEnd = updatedCaretPosition;
      });
    }
  };

  render(){
    const { text } = this.state;
    return (
      <TextareaAutosize
        {...this.props}
        value={text}
        inputRef={tag => (this.element = tag)}
        onChange={this.onChange}
        onKeyDown={this.onKeyDown}
      />
    );
  }
}
